import { method } from 'lodash'
import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'
import { ResourceDocument } from './resource'

export const experienceSchemaLiteral = {
  title: 'Experience Schema',
  description: 'Describes an experience, which can be a collection of resources',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    name: {
      type: 'string',
    },
    resources: {
      type: 'array',
      ref: 'resources',
      items: {
        type: 'string',
      },
    },
    createdAt: {
      type: ['string', 'null'],
    },
    updatedAt: {
      type: ['string', 'null'],
    },
  },
  required: ['id', 'name'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(experienceSchemaLiteral)

export type ExperienceDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const experienceSchema: RxJsonSchema<ExperienceDocType> = schemaTyped

export type ExperienceDocMethods = {
  test: () => void
}

export const experienceDocMethods = {
  test: () => {
    console.log('Experience document method called')
    return 'Test method executed'
  },
}

export type ExperienceDocument = RxDocument<ExperienceDocType, ExperienceDocMethods>

export type ExperienceCollectionMethods = {
  test: () => void
}

export type ExperienceCollection = RxCollection<ExperienceDocType, ExperienceDocMethods, ExperienceCollectionMethods>

export type ExperienceData = Omit<ExperienceDocument, 'resources'> & {
  resources: ResourceDocument[]
}
